import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { inject } from '@angular/core/testing';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { KaizenState } from '../models/Kaizen';
import { KaizenService } from '../Services/Kaizen.Service';
import { UntypedFormGroup, UntypedFormControl, FormArray, Validators, NgForm } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-dialogrejectconfirm',
    templateUrl: './dialogrejectconfirm.component.html',
    styleUrls: ['./dialogrejectconfirm.component.css'],
    standalone: false
})
export class DialogrejectconfirmComponent implements OnInit {

  
  kaizenstate: KaizenState = new KaizenState();
  kaizenid!: any;
  rejectForm!: UntypedFormGroup;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private kaizenService: KaizenService, private router: Router) 
  {
    this.kaizenid = data.id;
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.rejectForm = new UntypedFormGroup({
      cmdcomments: new UntypedFormControl(null,Validators.required)
    });

  }

  saveform(form :UntypedFormGroup) {
    this.kaizenstate.KaizenId = this.kaizenid;
    this.kaizenstate.KaizenStateID = 3;
    this.kaizenstate.CMDReviewerComments = form.value.cmdcomments;
    this.kaizenstate.pendingRevisionBy = localStorage.getItem('ademail')!;
    firstValueFrom(this.kaizenService.updateKaizenStatus(this.kaizenstate)).then((data) => {
      this.router.navigate(['/cmdreview'])
      .then(() => {
        window.location.reload();
      });
     });
  }
}
